<template>
  <div class="TeamAlbum" v-loading="loadingTrue">
    <!-- 相册 -->
    <div class="p_info" v-if="this.CertList.length">
      <div class="itemListCert">
        <el-row :gutter="20">
          <el-col :span="4.8" v-for="(item, index) in CertList" :key="index">
            <el-image
              style="width: 216px; height: 162px"
              :src="item.url"
              :preview-src-list="[item.url]"
            ></el-image>
          </el-col>
        </el-row>
      </div>
    </div>
    <div  class="nodata-box">
      <BaseEmptyData isDetail v-if="!this.CertList.length && !loadingTrue"></BaseEmptyData>
    </div>
  </div>
</template>

<script>
import { apiTeamDetail } from "@/api/apiTeamDetail"
export default {
  data() {
    return {
      CertList: [],
      loadingTrue: false,
      parms: {
        page: 1,
        limit: 20,
        companyNo: "",
        userNo: "",
        teamNo: ""
      }
    }
  },
  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData")
  },
  watch: {},
  created() {
    this.getfindAlbumByTeamNo()
  },
  methods: {
    // 获取视频相册
    async getfindAlbumByTeamNo() {
      this.loadingTrue = true
      if (this.$route.query.teamNo){
        this.parms.teamNo = this.$route.query.teamNo
      } 
      let res = await apiTeamDetail.GetTeamPhoto(this.parms.teamNo)
      if(res.data.code === 200){
        this.CertList = res.data.data
        this.loadingTrue = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.TeamAlbum {
  .p_info {
    color: #666;
    font-size: 14px;
    padding: 20px 20px 6px;
    width: 1160px;
  }
  /deep/.el-image{
    margin-bottom: 14px;
  }
  /deep/.empty-data{
    .nodata{
      .imgs{
        width: 100px;
        height: 100px;
      }
    }
  }
}
</style>
